// Wuffo Pets — scripts propios. Todo vanilla, sin librerías externas.

function wfInitReveal() {
  var els = document.querySelectorAll('.wf-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('wf-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wf-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function wfInitContadores() {
  var els = document.querySelectorAll('[data-wf-contador]');
  if (!els.length) return;
  var animar = function (el) {
    var fin = parseFloat(el.getAttribute('data-wf-contador')) || 0;
    var duracion = 1400;
    var inicio = null;
    function paso(ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min((ts - inicio) / duracion, 1);
      var valor = Math.floor(progreso * fin);
      el.textContent = valor.toLocaleString('es');
      if (progreso < 1) requestAnimationFrame(paso);
      else el.textContent = fin.toLocaleString('es');
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) {
    els.forEach(animar);
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function wfInitGaleriaProducto() {
  var wrap = document.querySelector('[data-wf-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-wf-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-wf-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.style.opacity = '0';
      window.setTimeout(function () {
        principal.setAttribute('src', full);
        principal.setAttribute('alt', alt);
        principal.style.opacity = '1';
      }, 150);
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

function wfInitVariantes() {
  var form = document.querySelector('[data-wf-form-producto]');
  if (!form) return;
  var selectores = form.querySelectorAll('[data-wf-opcion]');
  if (!selectores.length) return;
  var dataEl = document.querySelector('[data-wf-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-wf-precio]');
  var precioCompareEl = document.querySelector('[data-wf-precio-compare]');
  var boton = form.querySelector('[data-wf-boton-comprar]');

  function valoresSeleccionados() {
    var vals = [];
    selectores.forEach(function (sel) { vals.push(sel.value); });
    return vals;
  }

  function actualizar() {
    var vals = valoresSeleccionados();
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === vals[i]; });
    });
    if (!encontrada) return;
    inputId.value = encontrada.id;
    if (precioEl) precioEl.textContent = encontrada.precio;
    if (precioCompareEl) {
      if (encontrada.precioCompare) {
        precioCompareEl.textContent = encontrada.precioCompare;
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (boton) {
      if (encontrada.disponible) {
        boton.disabled = false;
        boton.setAttribute('data-estado', 'disponible');
      } else {
        boton.disabled = true;
        boton.setAttribute('data-estado', 'agotado');
      }
    }
  }

  selectores.forEach(function (sel) {
    sel.addEventListener('change', actualizar);
  });
  actualizar();
}

document.addEventListener('DOMContentLoaded', function () {
  wfInitReveal();
  wfInitContadores();
  wfInitGaleriaProducto();
  wfInitVariantes();
});
